import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useEffect } from 'react'
import { useState } from 'react';
import { FetchBranchShowData, FetchSectionShowData, FetchSemesterShowData, FetchSpecializationShowData, LocationShowdata, StudentAdd, StudentUpdate } from '../../services/LoginPageService';

const StudentModel = ({open, setOpen, isAddButton, editStudent,setRefreshData,setNotification}) => {
    const [studentId,setStudentId]= useState('');
    const [location,setLocation]= useState('');
    const [LocDisabled,setLocDisabled] = useState(false);
    const [locationList, setLocationList] = useState([]);
    const [branch,setBranch]= useState('');
    const [branchDisabled,setBranchDisabled]= useState(false);
    const [branchList, setBranchList] = useState([]);
    const[specialization,setSpecialization]=useState('');
    const[specializationDisabled,setSpecializationDisabled]=useState(false);
    const[specializationList,setSpecializationList]=useState([]);
    const[semester,setSemester]=useState('');
    const[semesterDisabled,setSemesterDisabled]=useState(false);
    const[semesterList,setSemesterList]=useState([]);
    const[section,setSection]=useState('');
    const[sectionDisabled,setSectionDisabled]=useState(false);
    const[sectionList,setSectionList]=useState([]);
    const [studentName,setStudentName]= useState('');
    const [gender,setGender]=useState('');
    const [contactNumber,setContactNumber]= useState('');
    const [emailId,setEmailId]= useState('');
    const [parentsNo,setParentsNo]= useState('');
    const [errorObject, setErrorObject] = useState({});
    const [parentsEmailId,setParentsEmailId]= useState('');
    const [parentsAltNo,setParentsAltNo]= useState('');
    const [registrationId,setRegistrationId]= useState('');
    const [rfid,setRfid]= useState('');

    const handleClose = () => {
        setOpen(false);
        clearForm();
    };

    useEffect(()=>{
        LocationShowdata(handleLocationshow,handleLocationshowException);

        setStudentId(editStudent?.studentId || '');
        setLocation(editStudent?.locationId || '');
        setBranch(editStudent?.branchId || '');
        setSpecialization(editStudent?.specializationsId || '');
        setSemester(editStudent?.semesterId || '');
        setSection(editStudent?.sectionId || '');
        setStudentName(editStudent?.studentName || '');
        setGender(editStudent?.gender || '');
        setContactNumber(editStudent?.studentContactNo || '');;
        setEmailId(editStudent?.emailId || '');
        setParentsNo(editStudent?.parentsNo || '');
        setParentsEmailId(editStudent?.parentsEmailId || '');
        setParentsAltNo (editStudent?.altContactNo || '');
        setParentsAltNo (editStudent?.altContactNo || '');
        setRegistrationId(editStudent?.registrationNo || '');
        setRfid(editStudent?.rfid || '');
        if(editStudent)
        {
            SelectionDisabled();
        }
    },[editStudent])

    const SelectionDisabled = ()=>{
        setLocDisabled(true);
        setBranchDisabled(true);
        setSpecializationDisabled(true);
        setSemesterDisabled(true);
        setSectionDisabled(true);
    }
    const handleLocationshow=(dataObject)=>{
        setLocationList(dataObject?.data);
        console.log(dataObject?.data);
        if(editStudent?.locationId)
        {
            FetchBranchShowData({id:editStudent?.locationId},handleBranchSuccess, handleBranchException);
        }
    }

    const handleLocationshowException=(error,errorMessage)=>{
        console.log(errorMessage);
    }

    const handleBranchSuccess = (dataObject) =>{
        console.log('data Branch');
        setBranchList(dataObject.data);
        if(editStudent?.branchId)
        {
            FetchSpecializationShowData({id:editStudent?.branchId},handleSpecializationSuccess, handleSpecializationException);
        }
    }

    const handleBranchException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const handleSpecializationSuccess = (dataObject) =>{
        console.log('data Branch');
        setSpecializationList(dataObject.data);
        if(editStudent?.specializationsId)
        {
            FetchSemesterShowData({id:editStudent?.specializationsId},handleSemesterSuccess, handleSemesterException);
        }
    }

    const handleSpecializationException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const handleSemesterSuccess = (dataObject) =>{
        console.log('data Branch');
        setSemesterList(dataObject.data);
        if(editStudent?.semesterId)
        {
            FetchSectionShowData({id:editStudent?.semesterId},handleSectionSuccess, handleSectionException);
        }
    }

    const handleSectionSuccess = (dataObject) =>{
        console.log('data Branch');
        setSectionList(dataObject.data);
    }

    const handleSectionException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const handleSemesterException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const onLocationChange=(e)=>{
        setLocation(e.target.value);
        FetchBranchShowData({id:e.target.value},handleBranchSuccess, handleBranchException);
    }

    const onBranchChange=(e)=>{
        setBranch(e.target.value);
        FetchSpecializationShowData({id:e.target.value},handleSpecializationSuccess, handleSpecializationException);
    }

    const onSpecializationChange=(e)=>{
        setSpecialization(e.target.value);
        FetchSemesterShowData({id:e.target.value},handleSemesterSuccess, handleSemesterException);
    }

    const onSemesterChange=(e)=>{
        setSemester(e.target.value);
        FetchSectionShowData({id:e.target.value},handleSectionSuccess, handleSectionException);
    }

    const onSectionChange=(e)=>{
        setSection(e.target.value);
    }
    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (!isValidEmail(emailId)) {
            // Show an error notification for an invalid email
            setNotification({
                status: true,
                type: 'error',
                message: 'Invalid email address. Please enter a valid email for Student.',
            });
            return; // Prevent form submission
        }
    
        if (parentsEmailId && !isValidEmail(parentsEmailId)) {
            // Show an error notification for an invalid email
            setNotification({
                status: true,
                type: 'error',
                message: 'Invalid email address. Please enter a valid email for Parents.',
            });
            return; // Prevent form submission
        }
    
        isAddButton === true ?
        (
            StudentAdd({
                id:location,
                location:location,
                branch:branch,
                specialization:specialization,
                semester:semester,
                studentId:studentId,
                studentName:studentName,
                gender:gender,
                studentContactNo:contactNumber,
                emailId:emailId,
                parentsNo:parentsNo,
                parentsEmailId:parentsEmailId,
                altContactNo:parentsAltNo,
                registrationNo:registrationId,
                rfid:rfid,
            }, handleAddSuccess, handleException)
        ) : (
            StudentUpdate({
            id: editStudent.id,             
            location:location,
            branch:branch,
            specialization:specialization,
            semester:semester,
            studentId:studentId,
            studentName:studentName,
            gender:gender,
            studentContactNo:contactNumber,
            emailId:emailId,
            parentsNo:parentsNo,
            parentsEmailId:parentsEmailId,
            altContactNo:parentsAltNo,
            registrationNo:registrationId,
            rfid:rfid,
            }, handleUpdateSuccess, handleException)
        );
    }
    const handleAddSuccess = (dataObject) => {
        console.log(dataObject);
        setNotification({
          status: true,
          type: 'success',
          message: dataObject.message,
        });
        setTimeout(() => {
            setOpen(false);
        }, 2000);
        setRefreshData(oldValue => !oldValue);
        clearForm();  
    }


    const clearForm = () => {
        setStudentId('');
        setLocation('');
        setBranch('');
        setSpecialization('');
        setSemester('');
        setSection('');
        setStudentName('');
        setGender('');
        setContactNumber('');
        setEmailId('');
        setParentsNo('');
        setParentsEmailId('');
        setParentsAltNo ('');
        setRegistrationId('');
        setRfid('');
        setRefreshData(oldValue => !oldValue);
        setLocDisabled(false);
        setBranchDisabled(false);
        setSpecializationDisabled(false);
        setSemesterDisabled(false);
        setSectionDisabled(false);
    }  
   
    const handleUpdateSuccess = (dataObject) => {
        console.log(dataObject);
        setNotification({
          status: true,
          type: 'success',
          message: dataObject.message,
        });
        setTimeout(() => {
            setOpen(false);
        }, 2000);
        setRefreshData(oldValue => !oldValue);
        clearForm();
    }


    const handleException = (errorObject, errorMessage) => {
        console.log(errorMessage);
        setNotification({
          status: true,
          type: 'error',
          message: errorMessage,
        });
        setStudentId('');
        setLocation('');
        setBranch('');
        setSpecialization('');
        setSemester('');
        setSection('');
        setStudentName('');
        setGender('');
        setContactNumber('');
        setEmailId('');
        setParentsNo('');
        setParentsEmailId('');
        setParentsAltNo ('');
        setRegistrationId('');
        setRfid('');
    }

    const isValidEmail = (email) => {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(email);
      };

      const isValidInput = (inputValue) => {
        // Regular expression to validate the input: only allow letters and spaces
        const regex = /^[A-Za-z\s]+$/;
        return regex.test(inputValue);
      };
    

      const handleStudentChange = (e) => {
        const inputValue = e.target.value;
        if (isValidInput(inputValue)) {
          setStudentName(inputValue);
        } else {
          // Check if the input value is empty after backspace, then clear the location
          if (inputValue === '') {
            setStudentName('');
          }
        }
      };

    return (
        <div>
            <Dialog sx={{ '& .MuiDialog-paper': { width: '70%', maxHeight: '100%' } }}
            fullWidth
            maxWidth='lg'
            open={open}>
                <form onSubmit={onSubmit}>
                    <DialogTitle style={{background:'#f7f7f7',color:'black'}}>
                        {isAddButton === true ? 'Add ' : 'Update '}Student
                    </DialogTitle>
                    <DialogContent >
                        <Grid container spacing={2} style={{marginTop:'15px'}}>
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
  <TextField
    fullWidth
    label="Campus Id"
    placeholder="Campus Id"
    variant="outlined"
    required
    onChange={(e) => {
      const value = e.target.value.toUpperCase(); // force uppercase
      const regex = /^[A-Z0-9]*$/; // allow only letters & numbers
      if (regex.test(value)) {
        setStudentId(value);
      }
    }}
    value={studentId}
    inputProps={{
      maxLength: 20, // optional length limit
    }}
  />
</Grid>

                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Location</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Location"
                                    placeholder='Location'
                                    disabled ={LocDisabled}
                                    value={location}
                                    required
                                    onChange={(e) => onLocationChange(e) }>
                                    {
                                        locationList.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.location}</MenuItem>
                                            )
                                        })

                                    }      
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Hostel Name</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Hostel Name"
                                    placeholder='Hostel Name'
                                    value={branch}
                                    disabled={branchDisabled}
                                    required
                                    onChange={(e) => onBranchChange(e) }>
                                        <MenuItem value="" key={0}>
                                            <em>Select Location</em>
                                        </MenuItem>
                                    {
                                        branchList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.branch}</MenuItem>
                                            )
                                        })
                                    }      
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Specialization</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Specialization"
                                    placeholder='Specialization'
                                    value={specialization}
                                    disabled={specializationDisabled}
                                    required
                                    onChange={(e) => onSpecializationChange(e) }>
                                        <MenuItem value="" key={0}>
                                            <em>Select Hostel Name</em>
                                        </MenuItem>
                                    {
                                        specializationList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.specialization}</MenuItem>
                                            )
                                        })

                                    }  
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Year</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Year"
                                    placeholder='Year'
                                    value={semester}
                                    
                                    required
                                    onChange={(e) => onSemesterChange(e) }>
                                        <MenuItem value="" key={0}>
                                            <em>Select Specialization</em>
                                        </MenuItem>
                                    {
                                        semesterList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.semester}</MenuItem>
                                            )
                                        })
                                    }      
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Section</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Section"
                                    placeholder='Section'
                                    value={section}
                                    required
                                    
                                    onChange={(e) => onSectionChange(e) }>
                                        <MenuItem value="" key={0}>
                                            <em>Select Year</em>
                                        </MenuItem>
                                    {
                                        sectionList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.section}</MenuItem>
                                            )
                                        })
                                    }      
                                    </Select>
                                </FormControl>
                            </Grid> */}
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                <TextField 
                                    fullWidth 
                                    label="Student Name"
                                    placeholder='Student Name'
                                    variant="outlined"
                                    required
                                    onChange={handleStudentChange}
                                    // onChange={(e) => { setStudentName(e.target.value) }}
                                    value={studentName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Gender"
                                    placeholder='Gender'
                                    required
                                    value={gender}
                                    onChange={handleGenderChange}>
                                    <MenuItem value={'Female'}>Female</MenuItem>
                                    <MenuItem value={'Male'}>Male</MenuItem>
                                    {/* <MenuItem value={'Others'}>Others </MenuItem> */}
                                    </Select>
                                </FormControl>
                            </Grid> 
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                <TextField
                                    sx={{ mb: 1 }}
                                    label="Primary Contact number"
                                    type="number"
                                    fullWidth
                                    value={contactNumber}
                                    variant="outlined"
                                    placeholder="Contact number"
                                    required
                                    onChange={(e) => { setContactNumber(e.target.value); }}
                                    onBlur={() => validateForNullValue(contactNumber, 'contactNumber')}
                                    autoComplete="off"
                                    error={errorObject?.primaryContactnumber?.errorStatus}
                                    helperText={errorObject?.primaryContactnumber?.helperText}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                <TextField 
                                    fullWidth 
                                    label="Email Id"
                                    placeholder='Email Id'
                                    variant="outlined"
                                    error={emailId !== '' && !isValidEmail(emailId)} // Check for error condition
                                    helperText={emailId !== '' && !isValidEmail(emailId) ? 'Invalid email address' : ''}
                                    onChange={(e) => { setEmailId(e.target.value) }}
                                    value={emailId}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                            <TextField
                                fullWidth
                                label="Parents No"
                                placeholder='Parents No'
                                variant="outlined"
                                required
                                onChange={(e) => {
                                    const phoneNo = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                    setParentsNo(phoneNo);
                                }}
                                value={parentsNo}
                            />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                <TextField 
                                    fullWidth 
                                    label="Parents Email Id"
                                    placeholder='Parents Email Id'
                                    variant="outlined"
                                    
                                    onChange={(e) => { setParentsEmailId(e.target.value) }}
                                    value={parentsEmailId}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                            <TextField
                                fullWidth
                                label="Alternate No"
                                placeholder='Alternate No'
                                variant="outlined"
                                onChange={(e) => {
                                    const alternateNo = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                    setParentsAltNo(alternateNo);
                                }}
                                value={parentsAltNo}
                            />
                            </Grid>
                            {/* <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                            <TextField
                                fullWidth
                                label="Registration Id"
                                placeholder='Registration Id'
                                variant="outlined"
                                onChange={(e) => {
                                    const registrationId = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                    setRegistrationId(registrationId);
                                }}
                                value={registrationId}
                            />
                            </Grid> */}
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
  <TextField
    fullWidth
    label="Registration Id"
    placeholder="Registration Id"
    variant="outlined"
    onChange={(e) => {
      const registrationId = e.target.value; // Allow all characters
      setRegistrationId(registrationId);
    }}
    value={registrationId}
  />
</Grid>

                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                <TextField 
                                    fullWidth 
                                    label="RFID/Finger Print No"
                                    placeholder='RFID/Finger Print No'
                                    variant="outlined"
                                    onChange={(e) => { setRfid(e.target.value) }}
                                    value={rfid}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button type='submit'>
                        {
                            isAddButton ? 'Add' : 'update'
                        }       
                        </Button>
                        <Button onClick={handleClose}>Cancel</Button>
                    </DialogActions>
                </form>
            </Dialog>  
        </div>
    )
}

export default StudentModel
